export default __webpack_public_path__ + "static/media/krakenlogo.c95ee7fa.png";